/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ScheduledBooking } from '../model/scheduledBooking';
import { ScheduledBookingRequest } from '../model/scheduledBookingRequest';
import { ValidationErrorResponse } from '../model/validationErrorResponse';
import { VehicleAvailabilityResponse } from '../model/vehicleAvailabilityResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ScheduledBookingApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create a new scheduled booking
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createScheduledBooking(body: ScheduledBookingRequest, observe?: 'body', reportProgress?: boolean): Observable<ScheduledBooking>;
    public createScheduledBooking(body: ScheduledBookingRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScheduledBooking>>;
    public createScheduledBooking(body: ScheduledBookingRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScheduledBooking>>;
    public createScheduledBooking(body: ScheduledBookingRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createScheduledBooking.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ScheduledBooking>('post',`${this.basePath}/scheduled-bookings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user&#x27;s scheduled bookings
     * 
     * @param userId User ID to get bookings for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScheduledBookings(userId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ScheduledBooking>>;
    public getScheduledBookings(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ScheduledBooking>>>;
    public getScheduledBookings(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ScheduledBooking>>>;
    public getScheduledBookings(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getScheduledBookings.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ScheduledBooking>>('get',`${this.basePath}/scheduled-bookings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get vehicle availability for scheduled bookings
     * 
     * @param cityId City ID to check availability for
     * @param startDateTime Start date time of the booking slot
     * @param endDateTime End date time of the booking slot
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getVehicleAvailability(cityId: number, startDateTime: Date, endDateTime: Date, observe?: 'body', reportProgress?: boolean): Observable<VehicleAvailabilityResponse>;
    public getVehicleAvailability(cityId: number, startDateTime: Date, endDateTime: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VehicleAvailabilityResponse>>;
    public getVehicleAvailability(cityId: number, startDateTime: Date, endDateTime: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VehicleAvailabilityResponse>>;
    public getVehicleAvailability(cityId: number, startDateTime: Date, endDateTime: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cityId === null || cityId === undefined) {
            throw new Error('Required parameter cityId was null or undefined when calling getVehicleAvailability.');
        }

        if (startDateTime === null || startDateTime === undefined) {
            throw new Error('Required parameter startDateTime was null or undefined when calling getVehicleAvailability.');
        }

        if (endDateTime === null || endDateTime === undefined) {
            throw new Error('Required parameter endDateTime was null or undefined when calling getVehicleAvailability.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cityId !== undefined && cityId !== null) {
            queryParameters = queryParameters.set('cityId', <any>cityId);
        }
        if (startDateTime !== undefined && startDateTime !== null) {
            queryParameters = queryParameters.set('startDateTime', <any>startDateTime.toISOString());
        }
        if (endDateTime !== undefined && endDateTime !== null) {
            queryParameters = queryParameters.set('endDateTime', <any>endDateTime.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<VehicleAvailabilityResponse>('get',`${this.basePath}/scheduled-bookings/availability`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Refund scheduled booking
     * Refunds a scheduled booking and releases associated resources. Requires the booking ID in the path and the caller must be either the owner or an admin.
     * @param id ID of the scheduled booking to refund
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public refundScheduledBooking(id: number, observe?: 'body', reportProgress?: boolean): Observable<ScheduledBooking>;
    public refundScheduledBooking(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ScheduledBooking>>;
    public refundScheduledBooking(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ScheduledBooking>>;
    public refundScheduledBooking(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling refundScheduledBooking.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ScheduledBooking>('post',`${this.basePath}/scheduled-bookings/${encodeURIComponent(String(id))}/refund`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
